<script>
// Iconsax "export" (linear): a seta saindo do quadrado — o glifo de "abrir em outro
// lugar" (tela do módulo, board, nova aba). Não confundir com `export.vue`, que é o
// ícone de EXPORTAR/baixar usado nos downloads (comissões, ws, tesouraria). Três
// `<path>` em stroke, sem ids.
export default {
  name: 'IconOpenExternal',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 10.9998L21.2 2.7998"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 6.8V2H17.2"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
